module.exports = __webpack_public_path__ + "img/media_facwbook.9515b94c.svg";